__webpack_require__.p = "/go/";